<template>
  <div class="container is-fluid">
    <button class="button">{{ filteredApplications.length }} applications</button>
    <div class="field has-addons is-pulled-right">
      <p class="control">
        <input
          class="input"
          type="search"
          v-model="applicationSearch"
          placeholder="Search applications"
          aria-label="Search applications by forename, surname, or email"
        >
      </p>
      <p class="control">
        <button class="button" @click="refreshPage()">Reload Page</button>
      </p>
    </div>

   

    
    
    <table class="table is-hoverable is-fullwidth is-size-6" id="applicationstable">
    	<thead>
       
    		<th>Name</th>
        <th>Email</th>
        <th>Phone</th>
   	 		<th>Submission Date</th>
   	 		<th>Governing Body</th>
        <th>&nbsp;</th>
          
    	</thead>
    	<tbody>
        <tr v-for="(row, index) in filteredApplications" :key="index"  >
           <td>
            <span v-if="row.contact_id > 0">
              <router-link :to="{path: '/contacts/' + row.contact_id}" target="_blank">{{row.forename}} {{row.surname}}</router-link>
            </span>
            <span v-else>
            {{row.forename}} {{row.surname}}
            </span>

            <span class="tag is-info" v-if="row.coaching==1">Coaching</span>
         </td>
				<td>{{ row.email }}</td>
        <td>{{ formatPhone(row.telephone, row.mobile) }}</td>
				<td>{{ row.date_formatted}}</td>
        <td>{{ row.governing_body_short_name }}</td>
      <td><button class="button is-small is-info" @click="processApplication(row)">Process</button></td>
			</tr>
      
    	</tbody>
    </table>

    <div class="modal" :class="{ 'is-active': showProcessModal }">
      <div class="modal-background" @click="closeProcessModal"></div>
      <div class="modal-card" style="width: 90vw; max-width: 960px;">
        <header class="modal-card-head">
          <p class="modal-card-title">Application contacts</p>
          <button class="delete" aria-label="close" @click="closeProcessModal"></button>
        </header>
        <section class="modal-card-body">
          <div v-if="selectedApplication">
            <p><strong>Name:</strong> {{ selectedApplication.forename }} {{ selectedApplication.surname }}</p>
            <p><strong>Email:</strong> {{ selectedApplication.email }}</p>
            <p><strong>Date of birth:</strong> {{ selectedApplication.dob }}</p>
          </div>

          <p v-if="loadingContacts">Loading contacts...</p>
          <p v-else-if="processError" class="has-text-danger">{{ processError }}</p>
          <table v-else-if="selectedApplication" class="table is-fullwidth">
            <thead>
              <tr>
                <th>Forename</th>
                <th>Surname</th>
                <th>Email</th>
                <th>Date of birth</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(contact, index) in sortedContacts"
                :key="contact.id || index"
                :class="{
                  'has-background-success has-text-white': Number(contact.priority) === 1,
                  'has-background-warning': Number(contact.priority) === 2
                }"
              >
                <td>{{ contact.forename }}</td>
                <td>{{ contact.surname }}</td>
                <td>{{ contact.email }}</td>
                <td>{{ contact.date_of_birth }}</td>
                <td>
                  <button
                    class="button is-small is-info"
                    :disabled="linkingContactId !== null || creatingContact"
                    @click="linkContact(contact)"
                  >
                    Link Contact
                  </button>
                </td>
              </tr>
              <tr v-if="!selectedApplication.contacts || !selectedApplication.contacts.length">
                <td colspan="5">No contacts found.</td>
              </tr>
            </tbody>
          </table>
          <button
            v-if="selectedApplication && !loadingContacts && !processError"
            class="button is-success mt-3"
            :disabled="creatingContact || linkingContactId !== null"
            @click="createAndLinkContact"
          >
            {{ creatingContact ? 'Creating and linking...' : 'Create Contact and Link' }}
          </button>
          <p v-if="linkingContactId !== null">Linking contact...</p>
          <p v-if="linkError" class="has-text-danger">{{ linkError }}</p>
          <p v-if="createContactError" class="has-text-danger">{{ createContactError }}</p>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="closeProcessModal">Close</button>
        </footer>
      </div>
    </div>

  </div>
</template>

<script>
import ApplicationService from '@/services/ApplicationService.js';
import ContactService from '@/services/ContactService.js';
//import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  data() {
    return {
      orders: [],
      errors: [],
      applications: [],
      applicationSearch: '',
      governing_bodies:[],
      council_areas:[],
      orderBy:"",
      rounds: [],
      accessToken:'',
      saving : false,
      selectedApplication: null,
      showProcessModal: false,
      loadingContacts: false,
      processError: '',
      linkingContactId: null,
      linkError: '',
      creatingContact: false,
      createContactError: ''
    }
  },
  props: [],
  
  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
      this.getApplications();
     
    });
  
  },
  computed: {
    sortedContacts() {
      const contacts = this.selectedApplication && this.selectedApplication.contacts;
      if (!Array.isArray(contacts)) {
        return [];
      }

      return contacts.slice().sort((first, second) => {
        const firstPriority = first.priority === null || first.priority === undefined ? Infinity : Number(first.priority);
        const secondPriority = second.priority === null || second.priority === undefined ? Infinity : Number(second.priority);
        return firstPriority - secondPriority;
      });
    },
    filteredApplications() {
      const query = this.applicationSearch.trim().toLowerCase();
      if (!query) {
        return this.applications;
      }

      return this.applications.filter(application => {
        const searchableText = [application.forename, application.surname, application.email]
          .map(value => (value || '').toLowerCase())
          .join(' ');
        return searchableText.includes(query);
      });
    }
  },
  watch: {
    '$route'() {
     this.getApplications();
     
    },
   
  },
  methods: {
    formatPhone(telephone, mobile) {
      if (telephone && mobile && telephone !== mobile) {
        return `${telephone}/${mobile}`;
      }
      return telephone || mobile || '';
    },
  	refreshPage() {
        this.getApplications();
        
    },
    
    async getApplications() {
      this.applications = []
      
     
      ApplicationService.getApplicationsNoContact(this.accessToken)
      .then(
        (applications => {
          this.$set(this, "applications", applications);
        }).bind(this)
      );
    },

    async processApplication(application) {
      this.selectedApplication = application;
      this.showProcessModal = true;
      this.loadingContacts = true;
      this.processError = '';
      this.linkingContactId = null;
      this.linkError = '';
      this.creatingContact = false;
      this.createContactError = '';

      try {
        this.selectedApplication = await ApplicationService.getApplication(this.accessToken, application.id);
        this.$set(this.selectedApplication, 'contacts', this.selectedApplication.contacts || []);
      } catch (error) {
        this.processError = 'Unable to load application contacts.';
      } finally {
        this.loadingContacts = false;
      }
    },

    async linkContact(contact) {
      this.linkingContactId = contact.id;
      this.linkError = '';

      try {
        await ApplicationService.linkContact(this.accessToken, this.selectedApplication.id, contact.id);
        this.closeProcessModal();
        this.getApplications();
      } catch (error) {
        this.linkError = 'Unable to link this contact.';
      } finally {
        this.linkingContactId = null;
      }
    },

    async createAndLinkContact() {
      this.creatingContact = true;
      this.createContactError = '';

      try {
        let newContact;
        try {
          newContact = await ContactService.saveContact(this.accessToken, {
            forename: this.selectedApplication.forename || '',
            surname: this.selectedApplication.surname || '',
            email: this.selectedApplication.email || '',
            mobile: this.selectedApplication.mobile || '',
            telephone: this.selectedApplication.telephone || '',
            date_of_birth: this.selectedApplication.dob
          });
        } catch (error) {
          this.createContactError = 'Unable to create contact.';
          return;
        }

        if (!newContact || !newContact.id) {
          this.createContactError = 'Contact was created, but no contact ID was returned.';
          return;
        }

        try {
          await ApplicationService.linkContact(this.accessToken, this.selectedApplication.id, newContact.id);
        } catch (error) {
          this.createContactError = 'Contact was created, but could not be linked to the application.';
          return;
        }

        this.closeProcessModal();
        this.getApplications();
      } finally {
        this.creatingContact = false;
      }
    },

    closeProcessModal() {
      this.showProcessModal = false;
    },
    
  }
}

// used to be on button  v-if="this.user["https://app.test202.co.uk/roles"].includes('sales')"
</script>

<style>
	
</style>
